module.exports = __webpack_public_path__ + "img/logo-small.83dc0244.svg";